module.exports = __webpack_public_path__ + "static/media/bg01.6e93f810.jpg";